<template>
  <!-- <div id="nav"> -->
  <!-- <router-link to="/create">Create</router-link> | -->
  <!-- <router-link to="/about">About</router-link> -->
  <!-- </div> -->
  <router-view />
</template>

<style>
body {
  background-color: transparent;
}

#app {
  font-family: Raleway, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: left; */
  color: #868686;
}
</style>
